<script setup lang="ts">
const { changeLanguage, getLanguageIdFromCode, getAvailableLanguages } = useInternationalization();
const { locale } = useI18n();

const updateSessionWithLanguage = async () => {
    const frontendLocale = locale.value;
    await getAvailableLanguages();
    await changeLanguage(getLanguageIdFromCode(frontendLocale));
};

await updateSessionWithLanguage();

const customerStore = useCustomerStore();
const { loading } = storeToRefs(customerStore);

const configStore = useConfigStore();
await configStore.loadConfig();

const wishlistEnabled = configStore.get('core.cart.wishlistEnabled');

await Promise.all([useGlobalSeo('IDS.online shop'), customerStore.refreshContext()]);

const { fetchVendorList } = useGroupedCartItems();
const { refreshCart } = useCart();
const { getWishlistProducts } = useWishlist();

useNotifications();
useBreadcrumbs();

await customerStore.refreshContext();
await refreshCart();
await fetchVendorList();

const route = useRoute();
if (route.path !== '/wishlist' && wishlistEnabled) {
    // If not on wishlist page we fetch for displaying the amount of items in the header
    await getWishlistProducts();
}
const isLoading = useState('isLoading');

</script>

<template>
    <div>
        <NuxtLoadingIndicator
            class="!bg-[#FFB13C] !bg-none"
            :height="7"
            :throttle="0"
        />
        <div
            v-if="isLoading"
            class="fixed left-0 top-0 w-1/3"
        >
            <div class="h-[7px] bg-[#FFB13C] " />
        </div>
        <NuxtRouteAnnouncer />
        <UtilityLoadingSpinner v-if="loading" />

        <LayoutHeader />
        <UtilityToastNotifications />

        <main>
            <LayoutBreadcrumbs />
            <NuxtPage />
        </main>

        <LayoutFooter />
        <CookieBanner />
    </div>
</template>
